module.exports = __webpack_public_path__ + "./assets/1-4ca5fb.bmp";


//////////////////
// WEBPACK FOOTER
// ./assets/1.bmp
// module id = 19
// module chunks = 0